// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aycj","toggleWrap":"styles_toggleWrap__2FMWO","content":"styles_content__1tvqS","selectAreaCode":"styles_selectAreaCode__20gX9"};